<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive" style="overflow: auto">
            <table class="table tablesorter">
              <tbody>
              <tr v-for="(values, articlesName) in incomes" :key="articlesName">
                <td style="width: 172px">
                  <p title="Article name">{{articlesName.split('_')[0]}}</p>
                </td>
                <td style="width: 172px">
                  <p title="Date of adding">{{getDate(values.date_of_adding)}}</p>
                </td>
                <td style="width: 308px">
                  <p title="Payee name">{{values.payee}}</p>
                </td>
                <td style="width: 130px; min-width: 100px">
                  <p :class="{ 'text-success': (parseInt(values.amount)>0), 'text-danger': (parseInt(values.amount)<0) }" title="Amount">{{formatter.format(values.amount/100)}}</p>
                </td>
                <td>
                  <p title="Description">{{values.description}}</p>
                </td>
              </tr>
              <tr>
                <td colspan="3"><h4><b>Total</b></h4></td>
                <td colspan="2"><h4><b :class="{ 'text-success': (parseInt(totalAmount)>0), 'text-danger': (parseInt(totalAmount)<0) }">{{formatter.format(totalAmount/100)}}</b></h4></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <base-button class="clock-button" size="lg" simple type="success" @click="toExcel">Export to excel</base-button>
    </div>
  </div>
</template>

<script>
  import {formatter, isMobile} from "../../plugins/axios";
  export default {
    name: "incomes-report",
    props: ['incomes', 'totalAmount'],
    data(){
      return{
        formatter: formatter,
        isMobile: isMobile,
      }
    },
    methods: {
      toExcel(){
        this.$emit('export-to-excel')
      },
      getDate(date){
        const locDate = new Date(date.split('-').join('/'));
        return locDate.toLocaleDateString();
      },
    }
  }
</script>

<style scoped>

</style>
